console.log('here');
document.addEventListener('DOMContentLoaded', function() {
    // Definición de los rangos de códigos postales
    var cpCDMX = {
        min: 1000,
        max: 5999
    };

    var cpEDOMEX = {
        min: 50000,
        max: 57999
    };

    // Obtener elementos del DOM
    var city = document.getElementById('select1');
    var postalCode = document.getElementById('TextField5');

    if (!city || !postalCode) {
        console.error('No se encontraron los elementos en el DOM.');
        return;
    }

    // Función para actualizar la ciudad en base al código postal
    function updateCity() {
        var code = parseInt(postalCode.value, 10); // Obtener el valor del código postal y convertirlo a entero

        if (code >= cpCDMX.min && code <= cpCDMX.max) {
            city.value = 'CDMX'; // Establecer el valor de la ciudad como CDMX
        } else if (code >= cpEDOMEX.min && code <= cpEDOMEX.max) {
            city.value = 'MEX'; // Establecer el valor de la ciudad como MEX
        } else {
            city.value = ''; // Limpiar el valor si el código postal no está en ningún rango definido
        }

        // Despachar el evento 'change' para el campo city
        var event = new Event('change');
        city.dispatchEvent(event);
    }

    // Agregar un evento para que la función se ejecute cuando el valor del código postal cambie
    postalCode.addEventListener('input', updateCity);
});


